var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.field),function(item,index){return [_c('b-badge',{key:index,staticClass:"m-25",attrs:{"variant":"dark"}},[_vm._v(_vm._s(item.Vehicle))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }